var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile:p-4 tablet:p-6",
      attrs: { "data-test": "tab-share" }
    },
    [
      _c(
        "tab-title",
        { attrs: { tab: "share" }, on: { close: _vm.closeTab } },
        [_vm._v(_vm._s(_vm.$t("SHARE.TITLE")))]
      ),
      _c(
        "div",
        { staticClass: "mb-4 block items-center justify-between tablet:flex" },
        [_c("channels")],
        1
      ),
      _vm.sharePlaytime
        ? _c(
            "div",
            { staticClass: "mx-2 mb-4" },
            [
              _c("playtime", {
                staticClass: "mx-2 mb-4 tablet:mx-0 tablet:mb-0"
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hasEmbedLink
        ? _c("embed-code", { staticClass: "mx-2 mb-4" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }